import {
  FloorExceptionalClosingHours,
  FloorExceptionalClosingHoursResponse,
  FloorExceptionalClosingHoursService,
} from '@jooxter/api';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { defaultOnError } from './default-error';

export const useCreateFloorExceptionalClosingHours = (
  onSuccess?: (data: FloorExceptionalClosingHoursResponse) => void,
  onError?: (error: AxiosError, variable: FloorExceptionalClosingHoursResponse) => void,
  onSettled?: () => void
) => {
  const mutationCreate = useMutation<FloorExceptionalClosingHoursResponse, AxiosError, FloorExceptionalClosingHours>({
    mutationFn: (floorExceptionalClosingHours: FloorExceptionalClosingHours) => {
      return FloorExceptionalClosingHoursService.create(floorExceptionalClosingHours);
    },
    onSuccess,
    onError: onError ?? defaultOnError,
    onSettled,
  });

  return mutationCreate;
};

export const useUpdateFloorExceptionalClosingHours = (
  onSuccess?: (data: FloorExceptionalClosingHoursResponse) => void,
  onError?: (error: AxiosError) => void,
  onSettled?: () => void
) => {
  const mutationUpdate = useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: FloorExceptionalClosingHours }) => {
      return FloorExceptionalClosingHoursService.update(id, payload);
    },
    onSuccess,
    onError: onError ?? defaultOnError,
    onSettled,
  });

  return mutationUpdate;
};

export const useDeleteFloorExceptionalClosingHours = (
  onSuccess?: () => void,
  onError?: (error: AxiosError) => void,
  onSettled?: () => void
) => {
  const mutationDelete = useMutation({
    mutationFn: (id: number) => {
      return FloorExceptionalClosingHoursService.delete(id);
    },
    onSuccess,
    onError: onError ?? defaultOnError,
    onSettled,
  });

  return mutationDelete;
};
